<div class="password-rule-checker grid">
  <div class="password-rule-checker-item sm:col-6 col-12" [ngClass]="hasLowerCase ? 'green' : showRed ? 'red' : ''">
    <i *ngIf="!hasLowerCase && !showRed" class="pi pi-circle password-rule-checker-icon" style="font-size: 21px"></i>
    <i *ngIf="!hasLowerCase && showRed" class="pi pi-times password-rule-checker-icon" style="font-size: 21px"></i>
    <i *ngIf="hasLowerCase" class="pi pi-check password-rule-checker-icon" style="font-size: 21px"></i>
    <span>One lowercase character</span>
  </div>
  <div class="password-rule-checker-item sm:col-6 col-12" [ngClass]="hasNonAlphas ? 'green' : showRed ? 'red' : ''">
    <i *ngIf="!hasNonAlphas && !showRed" class="pi pi-circle password-rule-checker-icon" style="font-size: 21px"></i>
    <i *ngIf="!hasNonAlphas && showRed" class="pi pi-times password-rule-checker-icon" style="font-size: 21px"></i>
    <i *ngIf="hasNonAlphas" class="pi pi-check password-rule-checker-icon" style="font-size: 21px"></i>
    <span>One special character</span>
  </div>
  <div class="password-rule-checker-item sm:col-6 col-12" [ngClass]="hasUpperCase ? 'green' : showRed ? 'red' : ''">
    <i *ngIf="!hasUpperCase && !showRed" class="pi pi-circle password-rule-checker-icon" style="font-size: 21px"></i>
    <i *ngIf="!hasUpperCase && showRed" class="pi pi-times password-rule-checker-icon" style="font-size: 21px"></i>
    <i *ngIf="hasUpperCase" class="pi pi-check password-rule-checker-icon" style="font-size: 21px"></i>
    <span>One uppercase character</span>
  </div>
  <div class="password-rule-checker-item sm:col-6 col-12" [ngClass]="hasLength ? 'green' : showRed ? 'red' : ''">
    <i *ngIf="!hasLength && !showRed" class="pi pi-circle password-rule-checker-icon" style="font-size: 21px"></i>
    <i *ngIf="!hasLength && showRed" class="pi pi-times password-rule-checker-icon" style="font-size: 21px"></i>
    <i *ngIf="hasLength" class="pi pi-check password-rule-checker-icon" style="font-size: 21px"></i>
    <span>8 characters minimum</span>
  </div>
  <div class="password-rule-checker-item sm:col-6 col-12" [ngClass]="hasNumbers ? 'green' : showRed ? 'red' : ''">
    <i *ngIf="!hasNumbers && !showRed" class="pi pi-circle password-rule-checker-icon" style="font-size: 21px"></i>
    <i *ngIf="!hasNumbers && showRed" class="pi pi-times password-rule-checker-icon" style="font-size: 21px"></i>
    <i *ngIf="hasNumbers" class="pi pi-check password-rule-checker-icon" style="font-size: 21px"></i>
    <span>One number</span>
  </div>
</div>
